import React from "react";
import { MyHrPaycardItem } from "my-hr/components";

type MyHrPaycardWrapperProps = {
  contract: any; // Replace 'any' with the actual type if known
  source: any[]; // Replace 'any' with the actual type if known
  collapse?: boolean;
  slot?: React.ReactNode;
};

export const MyHrPaycardWrapper: React.FC<MyHrPaycardWrapperProps> = ({
  contract,
  source,
  collapse,
  slot,
}) => {
  return (
    <>
      {source?.map((paycard, index) => {
        return (
          <MyHrPaycardItem
            key={`${source}-${index}`}
            paycard={paycard}
            index={index}
            contract={contract}
            collapse={collapse ?? false}
            slot={slot}
          />
        );
      })}
    </>
  );
};

export default MyHrPaycardWrapper;
